<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Evaluations/MyTeam/components/Sub'

    export default {
        components: {
            Grid,
        }
    }
</script>